import React from 'react';
import ClientActivity from './ClientActivity';
import { DragAndDropContextProvider } from '../../../../../context/DragDropContext';

const Activity = props => {
  return (
    <div className="flex-col-left" style={{ alignItems: 'stretch', maxHeight: '100%' }}>
      <DragAndDropContextProvider>
        <ClientActivity
          purchases={props?.client?.clientPurchases}
          associateRefObj={props.associateRefObj}
          activities={props?.client?.recentActivity}
          appointments={props?.client?.recentAppointments}
          activityList={props.activityList}
          client={props.client}
          auth={props.auth}
          refetchReminders={props.refetchReminders}
          refetchAutoMessages={props.refetchAutoMessages}
        />
      </DragAndDropContextProvider>
    </div>
  );
};
export default Activity;
